<script>
	import Router from "svelte-spa-router";
	import Login from "./paginas/login.svelte";
	import Inicio from "./paginas/inicio.svelte";
	import Deposito from "./paginas/deposito.svelte";
	import Locales from "./paginas/locales.svelte";
	import Empleados from "./paginas/empleados.svelte";
	import AgregarEmpleados from "./paginas/agregarEmpleado.svelte";
	import AgregarProducto from "./paginas/agregarProducto.svelte";
	import AgregarStock from "./paginas/cargarStock.svelte";
	import Local from "./paginas/local.svelte";
	//import Cuenta from "./paginas/cuenta.svelte";
	import Clientes from "./paginas/clientes.svelte";
	import Calendario from "./paginas/calendario.svelte";
	import Cliente from "./paginas/cliente.svelte";
	import Categorias from "./paginas/categorias.svelte";
	import Sorteo from "./paginas/sorteo.svelte";
	import NuevoLocal from "./paginas/nuevoLocal.svelte";

	let routes = {
		"/deposito/agregar":AgregarProducto,
		"/deposito/stock":AgregarStock,
		"/deposito/categorias":Categorias,
		"/deposito/:categoria":Deposito,
		"/deposito/:categoria/:id":AgregarProducto,
		"/empleados":Empleados,
		"/empleados/agregar":AgregarEmpleados,
		"/empleados/:id":AgregarEmpleados,
		"/":Login,
		"/home":Inicio,
		"/locales":Locales,
		"/local/:id":Local,
		"/local2/:id":NuevoLocal,
		"/clientes":Clientes,
		"/sorteo":Sorteo,
		"/cliente/:id":Cliente,
		"/calendario":Calendario
		
	}
</script>

<div class="container w-screen h-full max-w-full min-h-screen flex flex-col items-center bg-gray-300">
	<Router {routes} />
</div>
